import { render, staticRenderFns } from "./ClimateData.vue?vue&type=template&id=014f3feb&"
import script from "./ClimateData.vue?vue&type=script&lang=js&"
export * from "./ClimateData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports